import React from 'react';

interface Props {
  onCreate?: () => void;
}

const EventCreateButtonTw: React.FC<Props> = ({ onCreate }) => {
  return (
    <button
      type="button"
      className="flex-1 py-2 rounded border border-gray-300 text-gray-700 font-semibold hover:bg-gray-100 transition-all text-sm"
      onClick={onCreate}
    >
      Create
    </button>
  );
};

export default EventCreateButtonTw;
